/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const FALLBACK_EMPLOYEE_NAME = 'Unnamed Employee';
export const formatEmployeeName = (employee, { fallback = FALLBACK_EMPLOYEE_NAME } = {}) => {
  const first = employee?.first_name?.trim();
  const last = employee?.last_name?.trim();
  if (first || last) {
    return `${first || ''} ${last || ''}`.trim();
  }
  if (employee?.employee_name?.trim()) {
    return employee.employee_name.trim();
  }
  return fallback;
};
